import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Chatbot from './components/Chatbot/Chatbot';

// Layout Components
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Blog from "./components/Blog/Blog"
import ProtectedRoute from './components/ProtectedRoute';
import RoleBasedRoute from './components/RoleBasedRoute';

// Public Pages
import Home from "./components/Home/Home";
import Contact from "./components/Contact/Contact";
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './components/TermsOfService/TermsOfService';
import WhatsApp from "./components/WhatsApp/WhatsApp";
import Login from './components/Login/Login';
import Signup from './components/Signup/Signup';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResetPassword from './components/ResetPassword/ResetPassword';
import Profile from './components/Profile/Profile';

// Dashboard Components
import FounderDashboard from './components/Dashboards/FounderDashboard';
import MDDashboard from './components/Dashboards/MDDashboard';
import CEODashboard from './components/Dashboards/CEODashboard';
import COODashboard from './components/Dashboards/COODashboard';
import CFODashboard from './components/Dashboards/CFODashboard';
import EmployeeDashboard from './components/Dashboards/EmployeeDashboard';

const App = () => {
  return (
    <Router>
      <Navbar />
      <main className="main-content">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Protected Routes */}
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          
          {/* Role-Based Dashboards */}
          <Route path="/dashboard/founder" element={
            <RoleBasedRoute allowedRoles={['Founder & Chairman']}>
              <FounderDashboard />
            </RoleBasedRoute>
          } />
          
          <Route path="/dashboard/md" element={
            <RoleBasedRoute allowedRoles={['MD', 'Founder & Chairman']}>
              <MDDashboard />
            </RoleBasedRoute>
          } />
          
          <Route path="/dashboard/ceo" element={
            <RoleBasedRoute allowedRoles={['CEO', 'MD', 'Founder & Chairman']}>
              <CEODashboard />
            </RoleBasedRoute>
          } />
          
          <Route path="/dashboard/coo" element={
            <RoleBasedRoute allowedRoles={['COO', 'CEO', 'MD']}>
              <COODashboard />
            </RoleBasedRoute>
          } />
          
          <Route path="/dashboard/cfo" element={
            <RoleBasedRoute allowedRoles={['CFO', 'CEO', 'MD']}>
              <CFODashboard />
            </RoleBasedRoute>
          } />
          
          <Route path="/dashboard/employee" element={
            <RoleBasedRoute allowedRoles={['Employee', 'Team Lead', 'Manager']}>
              <EmployeeDashboard />
            </RoleBasedRoute>
          } />
        </Routes>
      </main>
      
      <WhatsApp />
      <Footer />
      <Chatbot />
    </Router>
  );
};

export default App;